//#region src/config/builtin.ts
const COLOR_THEME_IDS = [
	"magicmd.workbench-light",
	"magicmd.workbench-dark",
	"magicmd.github-light",
	"magicmd.github-dark",
	"magicmd.claude-light",
	"magicmd.comfort-light",
	"magicmd.comfort-dark",
	"magicmd.solarized-light",
	"magicmd.solarized-dark"
];
const PRODUCT_ICON_THEME_IDS = ["magicmd.default-product-icons", "magicmd.minimal-product-icons"];
const FILE_ICON_THEME_IDS = ["magicmd.default-file-icons", "magicmd.minimal-file-icons"];
const CONTENT_PROFILE_IDS = ["magicmd.documentation", "magicmd.reading"];
const PRESENTATION_PROFILE_IDS = ["magicmd.paper", "magicmd.presenter"];
const EDITOR_LOCALE_IDS = [
	"auto",
	"zh-CN",
	"en-US"
];
const LOG_LEVEL_IDS = [
	"debug",
	"info",
	"warn",
	"error"
];
const COLOR_THEME_SELECTOR_SCHEMA = {
	type: "string",
	enum: [...COLOR_THEME_IDS]
};
const PRODUCT_ICON_THEME_SELECTOR_SCHEMA = {
	type: "string",
	enum: [...PRODUCT_ICON_THEME_IDS]
};
const FILE_ICON_THEME_SELECTOR_SCHEMA = {
	type: "string",
	enum: [...FILE_ICON_THEME_IDS]
};
const CONTENT_PROFILE_SELECTOR_SCHEMA = {
	type: "string",
	enum: [...CONTENT_PROFILE_IDS]
};
const PRESENTATION_PROFILE_SELECTOR_SCHEMA = {
	type: "string",
	enum: [...PRESENTATION_PROFILE_IDS]
};
const EDITOR_LOCALE_SELECTOR_SCHEMA = {
	type: "string",
	enum: [...EDITOR_LOCALE_IDS]
};
const LOG_LEVEL_SELECTOR_SCHEMA = {
	type: "string",
	enum: [...LOG_LEVEL_IDS],
	legacyEnum: [
		"trace",
		"verbose",
		"warning"
	]
};
const EDITOR_SETTINGS_REGISTRY = [
	{
		key: "editor.autoSave",
		owner: "editor",
		scope: "workspace",
		schema: { type: "boolean" },
		defaultValue: false,
		effect: "immediate",
		targets: ["user", "workspace"],
		writableTargets: ["user", "workspace"],
		title: "%editor.settings.autoSave.title%",
		description: "%editor.settings.autoSave.description%"
	},
	{
		key: "editor.defaultPreviewWidth",
		owner: "editor",
		scope: "workspace",
		schema: {
			type: "string",
			enum: [
				"fill",
				"wide",
				"work",
				"reading",
				"compact"
			],
			legacyEnum: [
				"full",
				"prose",
				"3xl",
				"5xl"
			]
		},
		defaultValue: "fill",
		effect: "immediate",
		targets: ["user", "workspace"],
		writableTargets: ["user", "workspace"],
		title: "%editor.settings.defaultPreviewWidth.title%",
		description: "%editor.settings.defaultPreviewWidth.description%"
	},
	{
		key: "editor.defaultViewMode",
		owner: "editor",
		scope: "workspace",
		schema: {
			type: "string",
			enum: [
				"editor",
				"split",
				"preview"
			]
		},
		defaultValue: "editor",
		effect: "immediate",
		targets: ["user", "workspace"],
		writableTargets: ["user", "workspace"],
		title: "%editor.settings.defaultViewMode.title%",
		description: "%editor.settings.defaultViewMode.description%"
	},
	{
		key: "editor.codeMirror.hoverDetail",
		owner: "editor",
		scope: "workspace",
		schema: { type: "boolean" },
		defaultValue: true,
		effect: "immediate",
		targets: ["user", "workspace"],
		writableTargets: ["user", "workspace"],
		title: "%editor.settings.codeMirror.hoverDetail.title%",
		description: "%editor.settings.codeMirror.hoverDetail.description%"
	},
	{
		key: "editor.codeMirror.widgetMode",
		owner: "editor",
		scope: "workspace",
		schema: {
			type: "string",
			enum: ["pretty", "raw"]
		},
		defaultValue: "pretty",
		effect: "immediate",
		targets: ["user", "workspace"],
		writableTargets: ["user", "workspace"],
		title: "%editor.settings.codeMirror.widgetMode.title%",
		description: "%editor.settings.codeMirror.widgetMode.description%"
	},
	{
		key: "editor.showInlineDiagnostics",
		owner: "editor",
		scope: "workspace",
		schema: { type: "boolean" },
		defaultValue: true,
		effect: "immediate",
		targets: ["user", "workspace"],
		writableTargets: ["user", "workspace"],
		title: "%editor.settings.showInlineDiagnostics.title%",
		description: "%editor.settings.showInlineDiagnostics.description%"
	},
	{
		key: "editor.locale",
		owner: "editor",
		scope: "application",
		schema: EDITOR_LOCALE_SELECTOR_SCHEMA,
		defaultValue: "auto",
		effect: "immediate",
		targets: ["user"],
		writableTargets: ["user"],
		title: "%editor.settings.locale.title%",
		description: "%editor.settings.locale.description%"
	},
	{
		key: "editor.appearance.colorTheme",
		owner: "editor",
		scope: "workspace",
		schema: COLOR_THEME_SELECTOR_SCHEMA,
		defaultValue: "magicmd.workbench-light",
		effect: "immediate",
		targets: ["user", "workspace"],
		writableTargets: ["user", "workspace"],
		title: "%editor.settings.appearance.colorTheme.title%",
		description: "%editor.settings.appearance.colorTheme.description%"
	},
	{
		key: "editor.appearance.productIconTheme",
		owner: "editor",
		scope: "workspace",
		schema: PRODUCT_ICON_THEME_SELECTOR_SCHEMA,
		defaultValue: "magicmd.default-product-icons",
		effect: "immediate",
		targets: ["user", "workspace"],
		writableTargets: ["user", "workspace"],
		title: "%editor.settings.appearance.productIconTheme.title%",
		description: "%editor.settings.appearance.productIconTheme.description%"
	},
	{
		key: "editor.appearance.fileIconTheme",
		owner: "editor",
		scope: "workspace",
		schema: FILE_ICON_THEME_SELECTOR_SCHEMA,
		defaultValue: "magicmd.default-file-icons",
		effect: "immediate",
		targets: ["user", "workspace"],
		writableTargets: ["user", "workspace"],
		title: "%editor.settings.appearance.fileIconTheme.title%",
		description: "%editor.settings.appearance.fileIconTheme.description%"
	},
	{
		key: "editor.preview.contentProfile",
		owner: "editor",
		scope: "workspace",
		schema: CONTENT_PROFILE_SELECTOR_SCHEMA,
		defaultValue: "magicmd.documentation",
		effect: "immediate",
		targets: ["user", "workspace"],
		writableTargets: ["user", "workspace"],
		title: "%editor.settings.preview.contentProfile.title%",
		description: "%editor.settings.preview.contentProfile.description%"
	},
	{
		key: "editor.publish.presentationProfile",
		owner: "editor",
		scope: "workspace",
		schema: PRESENTATION_PROFILE_SELECTOR_SCHEMA,
		defaultValue: "magicmd.paper",
		effect: "immediate",
		targets: ["user", "workspace"],
		writableTargets: ["user", "workspace"],
		title: "%editor.settings.publish.presentationProfile.title%",
		description: "%editor.settings.publish.presentationProfile.description%"
	}
];
const ENGINE_SETTINGS_REGISTRY = [
	{
		key: "engine.docsDir",
		owner: "engine",
		scope: "machineOverridable",
		schema: { type: ["string", "null"] },
		defaultValue: null,
		effect: "nextSession",
		targets: ["remoteHost"],
		writableTargets: ["remoteHost"],
		title: "%editor.settings.engine.docsDir.title%",
		description: "%editor.settings.engine.docsDir.description%"
	},
	{
		key: "engine.pluginDirs",
		owner: "engine",
		scope: "machine",
		schema: {
			type: "array",
			items: { type: "string" }
		},
		defaultValue: [],
		effect: "nextSession",
		targets: ["remoteHost"],
		writableTargets: ["remoteHost"],
		title: "%editor.settings.engine.pluginDirs.title%",
		description: "%editor.settings.engine.pluginDirs.description%"
	},
	{
		key: "engine.cloudPluginSources",
		owner: "engine",
		scope: "machine",
		schema: {
			type: "array",
			items: { oneOf: [{ type: "string" }, {
				type: "object",
				required: ["url"],
				properties: {
					id: { type: "string" },
					kind: {
						type: "string",
						enum: ["manifest", "catalog"]
					},
					url: { type: "string" }
				},
				additionalProperties: false
			}] }
		},
		defaultValue: [],
		effect: "nextSession",
		targets: ["remoteHost"],
		writableTargets: ["remoteHost"],
		title: "%editor.settings.engine.cloudPluginSources.title%",
		description: "%editor.settings.engine.cloudPluginSources.description%"
	},
	{
		key: "engine.cloudExtensionSources",
		owner: "engine",
		scope: "machine",
		schema: {
			type: "array",
			items: { oneOf: [{ type: "string" }, {
				type: "object",
				required: ["url"],
				properties: {
					id: { type: "string" },
					kind: {
						type: "string",
						enum: ["manifest", "catalog"]
					},
					url: { type: "string" }
				},
				additionalProperties: false
			}] }
		},
		defaultValue: [],
		effect: "nextSession",
		targets: ["remoteHost"],
		writableTargets: ["remoteHost"],
		title: "%editor.settings.engine.cloudExtensionSources.title%",
		description: "%editor.settings.engine.cloudExtensionSources.description%"
	},
	{
		key: "engine.cloudSidecarSources",
		owner: "engine",
		scope: "machine",
		schema: {
			type: "array",
			items: { oneOf: [{ type: "string" }, {
				type: "object",
				required: ["url"],
				properties: {
					id: { type: "string" },
					kind: {
						type: "string",
						enum: ["manifest", "catalog"]
					},
					url: { type: "string" }
				},
				additionalProperties: false
			}] }
		},
		defaultValue: [],
		effect: "nextSession",
		targets: ["remoteHost"],
		writableTargets: ["remoteHost"],
		title: "%editor.settings.engine.cloudSidecarSources.title%",
		description: "%editor.settings.engine.cloudSidecarSources.description%"
	},
	{
		key: "engine.cloudSidecarCredentials",
		owner: "engine",
		scope: "machine",
		schema: { type: "string" },
		defaultValue: "",
		effect: "immediate",
		targets: ["remoteHost"],
		writableTargets: ["remoteHost"],
		title: "%editor.settings.engine.cloudSidecarCredentials.title%",
		description: "%editor.settings.engine.cloudSidecarCredentials.description%"
	},
	{
		key: "engine.cloudExtensionCredentials",
		owner: "engine",
		scope: "machine",
		schema: { type: "string" },
		defaultValue: "",
		effect: "immediate",
		targets: ["remoteHost"],
		writableTargets: ["remoteHost"],
		title: "%editor.settings.engine.cloudExtensionCredentials.title%",
		description: "%editor.settings.engine.cloudExtensionCredentials.description%"
	},
	{
		key: "engine.cloudPluginCredentials",
		owner: "engine",
		scope: "machine",
		schema: { type: "string" },
		defaultValue: "",
		effect: "immediate",
		targets: ["remoteHost"],
		writableTargets: ["remoteHost"],
		title: "%editor.settings.engine.cloudPluginCredentials.title%",
		description: "%editor.settings.engine.cloudPluginCredentials.description%"
	},
	{
		key: "engine.allowedSidecars",
		owner: "engine",
		scope: "machine",
		schema: {
			type: ["array", "null"],
			items: { type: "string" }
		},
		defaultValue: null,
		effect: "nextSession",
		targets: ["remoteHost"],
		writableTargets: ["remoteHost"],
		title: "%editor.settings.engine.allowedSidecars.title%",
		description: "%editor.settings.engine.allowedSidecars.description%"
	},
	{
		key: "engine.allowedOperationDirs",
		owner: "engine",
		scope: "machineOverridable",
		schema: {
			type: ["array", "null"],
			items: { type: "string" }
		},
		defaultValue: null,
		effect: "immediate",
		targets: ["remoteHost"],
		writableTargets: ["remoteHost"],
		title: "%editor.settings.engine.allowedOperationDirs.title%",
		description: "%editor.settings.engine.allowedOperationDirs.description%"
	},
	{
		key: "engine.logLevel",
		owner: "engine",
		scope: "machineOverridable",
		schema: LOG_LEVEL_SELECTOR_SCHEMA,
		defaultValue: "info",
		effect: "immediate",
		targets: ["remoteHost"],
		writableTargets: ["remoteHost"],
		title: "%editor.settings.engine.logLevel.title%",
		description: "%editor.settings.engine.logLevel.description%"
	},
	{
		key: "engine.startupTimeoutMs",
		owner: "engine",
		scope: "machineOverridable",
		schema: { type: "integer" },
		defaultValue: 1e4,
		effect: "restart",
		targets: ["remoteHost"],
		writableTargets: ["remoteHost"],
		title: "%editor.settings.engine.startupTimeoutMs.title%",
		description: "%editor.settings.engine.startupTimeoutMs.description%"
	},
	{
		key: "engine.mcp.defaultPort",
		owner: "engine",
		scope: "machineOverridable",
		schema: {
			type: ["integer", "null"],
			minimum: 1,
			maximum: 65535
		},
		defaultValue: null,
		effect: "nextSession",
		targets: ["remoteHost"],
		writableTargets: ["remoteHost"],
		title: "%editor.settings.engine.mcp.defaultPort.title%",
		description: "%editor.settings.engine.mcp.defaultPort.description%"
	}
];
const GATEWAY_SETTINGS_REGISTRY = [
	{
		key: "gateway.host",
		owner: "gateway",
		scope: "machine",
		schema: { type: "string" },
		defaultValue: "127.0.0.1",
		effect: "restart",
		targets: ["remoteHost"],
		writableTargets: ["remoteHost"],
		title: "%editor.settings.gateway.host.title%",
		description: "%editor.settings.gateway.host.description%"
	},
	{
		key: "gateway.port",
		owner: "gateway",
		scope: "machine",
		schema: { type: "integer" },
		defaultValue: 3721,
		effect: "restart",
		targets: ["remoteHost"],
		writableTargets: ["remoteHost"],
		title: "%editor.settings.gateway.port.title%",
		description: "%editor.settings.gateway.port.description%"
	},
	{
		key: "gateway.token",
		owner: "gateway",
		scope: "machine",
		schema: { type: ["string", "null"] },
		defaultValue: null,
		secret: true,
		effect: "restart",
		targets: ["remoteHost"],
		writableTargets: ["remoteHost"],
		title: "%editor.settings.gateway.token.title%",
		description: "%editor.settings.gateway.token.description%"
	},
	{
		key: "gateway.allowedOrigins",
		owner: "gateway",
		scope: "machine",
		schema: {
			type: "array",
			items: { type: "string" }
		},
		defaultValue: [],
		effect: "restart",
		targets: ["remoteHost"],
		writableTargets: ["remoteHost"],
		title: "%editor.settings.gateway.allowedOrigins.title%",
		description: "%editor.settings.gateway.allowedOrigins.description%"
	},
	{
		key: "gateway.logLevel",
		owner: "gateway",
		scope: "machine",
		schema: LOG_LEVEL_SELECTOR_SCHEMA,
		defaultValue: "info",
		effect: "immediate",
		targets: ["remoteHost"],
		writableTargets: ["remoteHost"],
		title: "%editor.settings.gateway.logLevel.title%",
		description: "%editor.settings.gateway.logLevel.description%"
	}
];
function createBuiltinSettingsRegistry() {
	return [
		...EDITOR_SETTINGS_REGISTRY,
		...ENGINE_SETTINGS_REGISTRY,
		...GATEWAY_SETTINGS_REGISTRY
	];
}
//#endregion
//#region src/config/utils.ts
function isPlainObject(value) {
	if (!value || typeof value !== "object" || Array.isArray(value)) return false;
	const proto = Object.getPrototypeOf(value);
	return proto === Object.prototype || proto === null;
}
function snakeToCamel(value) {
	return value.replace(/_([a-z0-9])/g, (_, char) => char.toUpperCase());
}
function camelToSnake(value) {
	return value.replace(/([a-z0-9])([A-Z])/g, "$1_$2").toLowerCase();
}
function normalizeConfigKeys(value) {
	if (Array.isArray(value)) return value.map((item) => normalizeConfigKeys(item));
	if (!isPlainObject(value)) return value;
	const next = {};
	for (const [key, nested] of Object.entries(value)) next[snakeToCamel(key)] = normalizeConfigKeys(nested);
	return next;
}
function denormalizeConfigKeys(value) {
	if (Array.isArray(value)) return value.map((item) => denormalizeConfigKeys(item));
	if (!isPlainObject(value)) return value;
	const next = {};
	for (const [key, nested] of Object.entries(value)) next[camelToSnake(key)] = denormalizeConfigKeys(nested);
	return next;
}
function flattenConfigObject(value, prefix = "") {
	const out = {};
	for (const [key, nested] of Object.entries(value)) {
		const nextKey = prefix ? `${prefix}.${key}` : key;
		if (isPlainObject(nested) && Object.keys(nested).length > 0) {
			Object.assign(out, flattenConfigObject(nested, nextKey));
			continue;
		}
		out[nextKey] = nested;
	}
	return out;
}
function expandFlatConfig(flat) {
	const out = {};
	for (const [key, value] of Object.entries(flat)) setNestedValue(out, key, value);
	return out;
}
function getNestedValue(input, dotPath) {
	const parts = dotPath.split(".").filter(Boolean);
	let current = input;
	for (const part of parts) {
		if (!isPlainObject(current)) return void 0;
		current = current[part];
	}
	return current;
}
function hasNestedValue(input, dotPath) {
	return getNestedValue(input, dotPath) !== void 0;
}
function setNestedValue(input, dotPath, value) {
	const parts = dotPath.split(".").filter(Boolean);
	if (parts.length === 0) return;
	let current = input;
	for (let index = 0; index < parts.length - 1; index += 1) {
		const key = parts[index];
		const next = current[key];
		if (!isPlainObject(next)) current[key] = {};
		current = current[key];
	}
	current[parts[parts.length - 1]] = value;
}
function deleteNestedValue(input, dotPath) {
	const parts = dotPath.split(".").filter(Boolean);
	if (parts.length === 0) return false;
	let current = input;
	const chain = [];
	for (let index = 0; index < parts.length - 1; index += 1) {
		if (!current) return false;
		const key = parts[index];
		const next = current[key];
		if (!isPlainObject(next)) return false;
		chain.push([current, key]);
		current = next;
	}
	if (!current || !(parts[parts.length - 1] in current)) return false;
	delete current[parts[parts.length - 1]];
	for (let index = chain.length - 1; index >= 0; index -= 1) {
		const [parent, key] = chain[index];
		const maybeObject = parent[key];
		if (isPlainObject(maybeObject) && Object.keys(maybeObject).length === 0) delete parent[key];
		else break;
	}
	return true;
}
function deepMergeConfigs(...values) {
	const out = {};
	for (const value of values) {
		if (!value) continue;
		for (const [key, nested] of Object.entries(value)) {
			if (isPlainObject(nested) && isPlainObject(out[key])) {
				out[key] = deepMergeConfigs(out[key], nested);
				continue;
			}
			if (Array.isArray(nested)) {
				out[key] = nested.map((item) => isPlainObject(item) ? deepMergeConfigs(item) : item);
				continue;
			}
			out[key] = nested;
		}
	}
	return out;
}
function filterRegistryByOwner(entries, owner) {
	if (!owner) return entries;
	return entries.filter((entry) => entry.owner === owner);
}
function validateValueAgainstSchema(value, schema) {
	if (value === void 0) return null;
	const enumValues = Array.isArray(schema.enum) ? schema.enum : null;
	const legacyEnumValues = Array.isArray(schema.legacyEnum) ? schema.legacyEnum : null;
	if (enumValues && !enumValues.some((item) => Object.is(item, value)) && !legacyEnumValues?.some((item) => Object.is(item, value))) return `Value must be one of: ${enumValues.join(", ")}`;
	const rawType = schema.type;
	const types = Array.isArray(rawType) ? rawType.filter((item) => typeof item === "string") : typeof rawType === "string" ? [rawType] : [];
	if (types.length === 0) return null;
	if (types.some((type) => {
		switch (type) {
			case "string": return typeof value === "string";
			case "boolean": return typeof value === "boolean";
			case "number": return typeof value === "number" && Number.isFinite(value);
			case "integer": return typeof value === "number" && Number.isInteger(value);
			case "array": {
				if (!Array.isArray(value)) return false;
				const itemSchema = isPlainObject(schema.items) ? schema.items : null;
				if (!itemSchema) return true;
				return value.every((item) => validateValueAgainstSchema(item, itemSchema) === null);
			}
			case "object": {
				if (!isPlainObject(value)) return false;
				const properties = isPlainObject(schema.properties) ? schema.properties : null;
				if (!properties) return true;
				return Object.entries(value).every(([key, nested]) => {
					const propSchema = properties[key];
					if (!isPlainObject(propSchema)) return true;
					return validateValueAgainstSchema(nested, propSchema) === null;
				});
			}
			case "null": return value === null;
			default: return true;
		}
	})) return null;
	return `Value does not match schema type: ${types.join(" | ")}`;
}
function createDiagnostic(message, options) {
	return {
		severity: options.severity ?? "warning",
		code: options.code,
		message,
		key: options.key,
		owner: options.owner,
		target: options.target,
		source: options.source,
		filePath: options.filePath
	};
}
//#endregion
//#region src/config/toml.ts
function parseToml(input, options) {
	const data = {};
	const diagnostics = [];
	let currentTable = [];
	input.split(/\r?\n/).forEach((line, index) => {
		const trimmed = stripInlineComment(line).trim();
		if (!trimmed) return;
		if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
			const parsed = splitTomlPath(trimmed.slice(1, -1).trim());
			if (!parsed) {
				diagnostics.push(createDiagnostic(`Invalid TOML table header on line ${index + 1}`, {
					code: "toml.invalidTable",
					severity: "error",
					source: "toml",
					filePath: options?.filePath
				}));
				return;
			}
			currentTable = parsed;
			ensureTable(data, currentTable);
			return;
		}
		const eqIndex = findAssignmentIndex(trimmed);
		if (eqIndex < 0) {
			diagnostics.push(createDiagnostic(`Invalid TOML assignment on line ${index + 1}`, {
				code: "toml.invalidAssignment",
				severity: "error",
				source: "toml",
				filePath: options?.filePath
			}));
			return;
		}
		const rawKey = trimmed.slice(0, eqIndex).trim();
		const rawValue = trimmed.slice(eqIndex + 1).trim();
		const keyParts = splitTomlPath(rawKey);
		if (!keyParts) {
			diagnostics.push(createDiagnostic(`Invalid TOML key on line ${index + 1}`, {
				code: "toml.invalidKey",
				severity: "error",
				source: "toml",
				filePath: options?.filePath
			}));
			return;
		}
		const value = parseTomlValue(rawValue, diagnostics, index + 1, options?.filePath);
		setNestedValueAtPath(data, [...currentTable, ...keyParts], value);
	});
	return {
		data: normalizeConfigKeys(data),
		diagnostics
	};
}
function stringifyToml(input) {
	const data = denormalizeConfigKeys(input);
	const lines = [];
	const writeTable = (value, path) => {
		const scalarEntries = Object.entries(value).filter(([, nested]) => !isPlainObject(nested));
		const objectEntries = Object.entries(value).filter(([, nested]) => isPlainObject(nested));
		if (path.length > 0) {
			if (lines.length > 0) lines.push("");
			lines.push(`[${path.map(formatTomlKey).join(".")}]`);
		}
		for (const [key, nested] of scalarEntries) lines.push(`${formatTomlKey(key)} = ${formatTomlValue(nested)}`);
		for (const [key, nested] of objectEntries) writeTable(nested, [...path, key]);
	};
	writeTable(data, []);
	return `${lines.join("\n")}\n`;
}
function ensureTable(target, path) {
	let current = target;
	for (const segment of path) {
		if (!isPlainObject(current[segment])) current[segment] = {};
		current = current[segment];
	}
}
function setNestedValueAtPath(target, path, value) {
	if (path.length === 0) return;
	let current = target;
	for (let index = 0; index < path.length - 1; index += 1) {
		const segment = path[index];
		if (!isPlainObject(current[segment])) current[segment] = {};
		current = current[segment];
	}
	current[path[path.length - 1]] = value;
}
function stripInlineComment(line) {
	let inSingle = false;
	let inDouble = false;
	let escaped = false;
	for (let index = 0; index < line.length; index += 1) {
		const char = line[index];
		if (escaped) {
			escaped = false;
			continue;
		}
		if (char === "\\" && inDouble) {
			escaped = true;
			continue;
		}
		if (char === "'" && !inDouble) {
			inSingle = !inSingle;
			continue;
		}
		if (char === "\"" && !inSingle) {
			inDouble = !inDouble;
			continue;
		}
		if (char === "#" && !inSingle && !inDouble) return line.slice(0, index);
	}
	return line;
}
function findAssignmentIndex(line) {
	let inSingle = false;
	let inDouble = false;
	let escaped = false;
	let bracketDepth = 0;
	for (let index = 0; index < line.length; index += 1) {
		const char = line[index];
		if (escaped) {
			escaped = false;
			continue;
		}
		if (char === "\\" && inDouble) {
			escaped = true;
			continue;
		}
		if (char === "'" && !inDouble) {
			inSingle = !inSingle;
			continue;
		}
		if (char === "\"" && !inSingle) {
			inDouble = !inDouble;
			continue;
		}
		if (inSingle || inDouble) continue;
		if (char === "[") bracketDepth += 1;
		if (char === "]" && bracketDepth > 0) bracketDepth -= 1;
		if (char === "=" && bracketDepth === 0) return index;
	}
	return -1;
}
function splitTomlPath(value) {
	const parts = [];
	let current = "";
	let inQuotes = false;
	let escaped = false;
	for (let index = 0; index < value.length; index += 1) {
		const char = value[index];
		if (escaped) {
			current += char;
			escaped = false;
			continue;
		}
		if (char === "\\") {
			escaped = inQuotes;
			current += char;
			continue;
		}
		if (char === "\"") {
			inQuotes = !inQuotes;
			continue;
		}
		if (char === "." && !inQuotes) {
			const segment = normalizeTomlPathSegment(current);
			if (!segment) return null;
			parts.push(segment);
			current = "";
			continue;
		}
		current += char;
	}
	if (inQuotes) return null;
	const finalSegment = normalizeTomlPathSegment(current);
	if (!finalSegment) return null;
	parts.push(finalSegment);
	return parts;
}
function normalizeTomlPathSegment(value) {
	const trimmed = value.trim();
	if (!trimmed) return null;
	if (trimmed.startsWith("\"") && trimmed.endsWith("\"")) try {
		return JSON.parse(trimmed);
	} catch {
		return null;
	}
	return trimmed;
}
function parseTomlValue(value, diagnostics, lineNo, filePath) {
	const trimmed = value.trim();
	if (trimmed === "true") return true;
	if (trimmed === "false") return false;
	if (/^-?\d+$/.test(trimmed)) return Number.parseInt(trimmed, 10);
	if (/^-?\d+\.\d+$/.test(trimmed)) return Number.parseFloat(trimmed);
	if (trimmed.startsWith("\"") && trimmed.endsWith("\"")) try {
		return JSON.parse(trimmed);
	} catch {
		diagnostics.push(createDiagnostic(`Invalid TOML string on line ${lineNo}`, {
			code: "toml.invalidString",
			severity: "error",
			source: "toml",
			filePath
		}));
		return trimmed;
	}
	if (trimmed.startsWith("'") && trimmed.endsWith("'")) return trimmed.slice(1, -1);
	if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
		const inner = trimmed.slice(1, -1).trim();
		if (!inner) return [];
		return splitTopLevel(inner).map((item) => parseTomlValue(item, diagnostics, lineNo, filePath));
	}
	return trimmed;
}
function splitTopLevel(value) {
	const parts = [];
	let current = "";
	let inSingle = false;
	let inDouble = false;
	let escaped = false;
	let arrayDepth = 0;
	for (let index = 0; index < value.length; index += 1) {
		const char = value[index];
		if (escaped) {
			current += char;
			escaped = false;
			continue;
		}
		if (char === "\\" && inDouble) {
			escaped = true;
			current += char;
			continue;
		}
		if (char === "'" && !inDouble) {
			inSingle = !inSingle;
			current += char;
			continue;
		}
		if (char === "\"" && !inSingle) {
			inDouble = !inDouble;
			current += char;
			continue;
		}
		if (!inSingle && !inDouble) {
			if (char === "[") arrayDepth += 1;
			if (char === "]" && arrayDepth > 0) arrayDepth -= 1;
			if (char === "," && arrayDepth === 0) {
				parts.push(current.trim());
				current = "";
				continue;
			}
		}
		current += char;
	}
	if (current.trim()) parts.push(current.trim());
	return parts;
}
function formatTomlKey(value) {
	return /^[A-Za-z0-9_]+$/.test(value) ? value : JSON.stringify(value);
}
function formatTomlValue(value) {
	if (value === null || value === void 0) return "\"\"";
	if (typeof value === "string") return JSON.stringify(value);
	if (typeof value === "number" || typeof value === "boolean") return String(value);
	if (Array.isArray(value)) return `[${value.map((item) => formatTomlValue(item)).join(", ")}]`;
	return JSON.stringify(value);
}
//#endregion
export { ENGINE_SETTINGS_REGISTRY as _, deleteNestedValue as a, filterRegistryByOwner as c, hasNestedValue as d, isPlainObject as f, EDITOR_SETTINGS_REGISTRY as g, validateValueAgainstSchema as h, deepMergeConfigs as i, flattenConfigObject as l, setNestedValue as m, stringifyToml as n, denormalizeConfigKeys as o, normalizeConfigKeys as p, createDiagnostic as r, expandFlatConfig as s, parseToml as t, getNestedValue as u, GATEWAY_SETTINGS_REGISTRY as v, createBuiltinSettingsRegistry as y };
